
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(196|236|574|800)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
